export interface AXNavigationAuthorityRule {
  readonly from: string;
  readonly to: string;
  readonly allowed: boolean;
}

const AX_NAVIGATION_RULES: readonly AXNavigationAuthorityRule[] =
Object.freeze([
  { from: '/',                        to: '/login',                   allowed: true },
  { from: '/',                        to: '/signup',                  allowed: true },
  { from: '/signup',                  to: '/login',                   allowed: true },
  { from: '/login',                   to: '/app',                     allowed: true },
  { from: '/app',                     to: '/settings',                allowed: true },
  { from: '/settings',                to: '/governor-command-center', allowed: true },
  { from: '/governor-command-center', to: '/app',                     allowed: true },
]);

export function getAXNavigationAuthority():
readonly AXNavigationAuthorityRule[] {
  return AX_NAVIGATION_RULES;
}
